// extracted by mini-css-extract-plugin
export default {"main":"ConnectingModal_main__kP25f"};